
import { useRef, useCallback, useEffect } from 'react';

const useClickOutside = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      // Check if the click is on a portal element (dropdown content)
      const target = event.target as Element;
      const isPortalClick = target.closest('[data-portal="dropdown"]') || 
                           target.closest('.fixed') && target.closest('.shadow-lg');
      
      if (!isPortalClick) {
        callback();
      }
    }
  }, [callback]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [handleClickOutside]);

  return ref;
};

export default useClickOutside;
